<div class="run-outcome" [class]="'run-outcome--' + view.tone">
  <mat-icon class="run-outcome__icon" aria-hidden="true">{{ icon }}</mat-icon>
  <span class="run-outcome__text">
    <span class="run-outcome__title">{{ view.titleKey | translate: view.titleParams }}</span>
    @if (view.detailKey) {
      <span class="run-outcome__detail">{{ view.detailKey | translate: view.detailParams }}</span>
    } @else if (view.detailText) {
      <span class="run-outcome__detail">{{ view.detailText }}</span>
    }
  </span>
</div>
